import React from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

function Editinterassignment() {
  const accesstoken = localStorage.getItem("token");
  const accessuserid = localStorage.getItem("id");
  const Swal = require("sweetalert2");
  const { staff_id } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const selval =
    location.state?.selectedOptions ||
    sessionStorage.getItem("selectedOptions");
  const searchVals =
    location.state?.searchVal || sessionStorage.getItem("searchVal");

  const [staff_name, setstaff_name] = useState("");
  const [staff_code, setstaff_code] = useState("");
  const [staff_dept, setstaff_dept] = useState("");
  const [staff_deptcode, setstaff_deptcode] = useState("");
  const [staff_deptid, setstaff_deptid] = useState("");
  const [staff_typename, setstaff_typename] = useState("");
  const [x, setX] = useState("");
  const [xy, setXY] = useState("");
  const [staff_typeid, setstaff_typeid] = useState("");
  const [staff_branchshift, setstaff_branchshift] = useState([]);
  const [status, setstaff_status] = useState("");
  const [shiftFrom, setShiftfrom] = useState("");
  const [shiftTo, setShiftTo] = useState("");
  const [staffBranch, setStaffBranch] = useState("");
  const [staffBranchid, setStaffBranchid] = useState("");
  const [branch_name, setbranch_name] = useState("");
  const [oldshift, setOldshift] = useState("");

  const [interbranchid, setInterBranchid] = useState("");
  const [interbranchname, setInterBranchname] = useState("");
  const [intertypeid, setIntertypeid] = useState("");
  const [intertypename, setIntertypename] = useState("");
  const [interfrom, setInterFrom] = useState("");
  const [interto, setInterTo] = useState("");

  const handleBack = () => {
    const tab = location.state?.tab || "inter";
    navigate("/shiftassignment", {
      state: { tab, selval: selval, searchVal: searchVals },
    });
  };

  useEffect(() => {
    axios
      .get(baseurladdress + `editshiftassignments/` + staff_id, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        setstaff_name(data[0].staff_name);
        setstaff_code(data[0].staff_code);
        setstaff_dept(data[0].dept_name);
        setstaff_deptcode(data[0].dept_code);
        setstaff_deptid(data[0].dept_id);
        setstaff_typeid(data[0].staff_branchshift);
        setstaff_typename(data[0].type_name);
        setXY(data[0].staff_status);
        setStaffBranch(data[0].branch_name);
        setStaffBranchid(data[0].branch_id);
        setstaff_branchshift(data[0].staff_branchshift);
        setOldshift(data[0].type_name);
        const check = data[0].staff_status == "1" ? true : false;
        setX(check);
        const fromDate = moment(data[0].assing_fromdate).format("YYYY-MM-DD");
        const toDate = moment(data[0].assign_todate).format("YYYY-MM-DD");
        setShiftfrom(fromDate);
        setShiftTo(toDate);
        // setShiftfrom(data[0].assing_fromdate);
        // setShiftTo(data[0].assign_todate);
        getshifttype();
      });
  }, [staff_id]);

  const getshifttype = () => {
    axios
      .get(baseurladdress + `getallshifttype`, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        console.log(data);
        const user = data.map((item) => (
          <option key={item.type_id} value={item.type_id}>
            {item.type_name}
          </option>
        ));
        setstaff_branchshift(user);
      })
      .catch((error) => {
        alert(error);
      });
  };

  // get all Branches

  useEffect(() => {
    const getbranch = () => {
      axios
        .get(baseurladdress + `getallbranchs`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then((res) => {
          const data = res.data.response;
          // console.log(data);
          const user = data.map((item, index) => {
            return <option value={item.branch_id}> {item.branch_name} </option>;
          });
          setbranch_name(user);
        })
        .catch((error) => {
          alert(error);
        });
    };
    getbranch();
  }, []);

  // ADD NEW INTER SHIFT

  const handleNewInterassignment = (e) => {
    e.preventDefault();
    var data = {
      interstaff_id: staff_id,
      intersftaff_name: staff_name,
      interbranch_id: interbranchid,
      interbranch_name: interbranchname,
      intertype_id: intertypeid,
      intertype_name: intertypename,
      intershif_from: interfrom,
      intershift_to: interto,
      intershift_crtdby: accessuserid,
    };
    axios
      .post(baseurladdress + `addIntershiftAssignment`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((result) => {
        console.log("reslt:", result);
        const Data = result.data.status;
        if (Data == "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "Shift Type Data Updated successfully",
          });
          navigate("/shiftassignment");
        } else {
          alert("Failed");
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  return (
    <div>
      <Topnavbar />
      <Sidennav />
      <div
        class="content-wrap"
        style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
      >
        <div className="container-fluid">
          <div style={{ display: "flex" }}>
            <button
              onClick={handleBack}
              className="float active-link"
              style={{ border: "none", background: " rgb(63, 41, 184)" }}
            >
              <i className="fa fa-arrow-left my-float"></i>
            </button>
          </div>

          <form>
            <div className="row">
              <div class="col-xl-12 col-xxl-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">EDIT INTER SHIFT ASSIGNMENT</h4>
                  </div>
                  <div class="card-body">
                    <div class="basic-form mt-3">
                      <div class="form-row">
                        <div class="col-sm-2 mt-2 mt-sm-0">
                          <h6>Staff Code</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                            value={staff_code}
                          />
                        </div>
                        <div class="col-sm-4 mt-2 mt-sm-0">
                          <h6>Staff Name</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                            value={staff_name}
                          />
                        </div>

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Branch</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                            value={staffBranch}
                          />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Department</h6>
                          <input
                            type="text"
                            class="form-control"
                            value={staff_dept}
                            required
                            readOnly
                          />
                        </div>
                        <div className="col-sm-2 mt-2 mt-sm-0">
                          <h6>Department Code</h6>
                          <input
                            class="form-control"
                            readOnly
                            value={staff_deptcode}
                          />
                        </div>

                        {/* <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Shift Type</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Shifttype"
                                                        value={staff_typeid}
                                                        onChange={(e) => { getshifttype(e.target.value);setstaff_typeid(e.target.value)}}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {staff_branchshift}
                                                    </select>
                                                </div> */}

                        <div className="col-sm-4 mt-2 mt-sm-0">
                          <h6>Shift Type</h6>
                          <input
                            class="form-control"
                            readOnly
                            value={oldshift}
                          />
                        </div>

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>From Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            value={shiftFrom}
                            readOnly
                            required
                          />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>To Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            value={shiftTo}
                            readOnly
                            required
                          />
                        </div>
                        {/* <div class="col-sm-2 mt-2 mt-sm-0">
                                                    <br />
                                                    <input readOnly type="checkbox" name="dept_status" className="selectsingle checku" id="exampleCheck1"
                                                          /><label className="form__label textal ml-2" for="clienttype">
                                                        Status
                                                    </label>
                                                </div> */}
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>New Assign Branch</h6>
                          <select
                            className="form-control select"
                            name="branchs"
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedName =
                                e.target.options[e.target.selectedIndex].text;
                              setInterBranchid(selectedId);
                              setInterBranchname(selectedName);
                            }}
                          >
                            <option value="" selected>
                              Select Branch
                            </option>
                            {branch_name}
                          </select>
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Shift Type</h6>
                          <select
                            className="form-control select"
                            name="Shifttypes"
                            onChange={(e) => {
                              const selectedIds = e.target.value;
                              const selectedNames =
                                e.target.options[e.target.selectedIndex].text;
                              setIntertypeid(selectedIds);
                              setIntertypename(selectedNames);
                            }}
                          >
                            <option value="" selected>
                              Select
                            </option>
                            {staff_branchshift}
                          </select>
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>From Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            required
                            onChange={(e) => setInterFrom(e.target.value)}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>To Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            required
                            onChange={(e) => setInterTo(e.target.value)}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 offset-6 mt-4">
                    <button
                      type="button"
                      class="btn btn-primary mb-2"
                      onClick={handleNewInterassignment}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Editinterassignment;
